import { Tenant } from '@/entities/tenant.entity';
import { defineStore } from 'pinia';
import { PartnerTenantState } from '@/entities/partnerTenantState.entity';
import { partnerTenantStateStorage } from '@/storages/browser.storage';

type AppState = {
  tenant: Tenant;
};

const loadPartnerTenantState = (): PartnerTenantState => partnerTenantStateStorage.get();

export const usePartnerTenantStore = defineStore('partner-tenant-store', {
  state: (): AppState => ({
    tenant: loadPartnerTenantState()?.selectedTenant ?? null,
  }),
  actions: {
    setTenant(tenant: Tenant) {
      this.tenant = tenant;

      partnerTenantStateStorage.set({
        selectedTenant: this.tenant,
      });
    },
    clearTenant() {
      this.tenant = undefined;

      partnerTenantStateStorage.set({
        selectedTenant: undefined,
      });
    },
  },
});
